<template>
	<b-container class="show-document">
		<div class="doc-body" style="text-align: center; align-items: center">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
				</div>
				<div class="pull-right">
					<b-button variant="outline-dark" class="mr-2" @click="print">
						<i class="fa fa-print"></i> Печать {{ $t('incomes.create.prices') }}
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<div>
				<div v-if="$route.params.depId == item.departmentId || $route.params.depId == 'null'" class="printElement" v-for="(item, index) in items.pricingByDifferences" :key="`prices-generate-${index}`">
					<p class="text-center specialBarcode" style="padding-top: 20px"><b>{{item.barcode}}</b> - <span v-for="(dep, inde) in deps" :key="`deps-${inde}`" v-if="dep.id === item.departmentId">{{ dep.name }}</span></p>
					<p class="text-center info">{{ item.name }}</p>
					<p>
						<span v-if="(item.priceUzs - item.oldPriceUzs) < 0" style="position: relative; font-size: 25px">
							<b style="position: absolute; top: -10px; left: -90px">$ {{ item.oldPriceUzs * (item.multiBarcodes[0].ratio ? item.multiBarcodes[0].ratio : 1) }}</b>
							<span style="position: absolute; top: -35px; left: -60px; font-size: 80px; transform: rotate(105deg); font-weight: lighter !important; font-family: Times, Times New Roman, Georgia, serif">|</span>
						</span>
						<b class="price">$ {{ item.priceUzs * (item.multiBarcodes[0].ratio ? item.multiBarcodes[0].ratio : 1) }}</b>
					</p>
					<barcode :value="item.multiBarcodes[0]" :options="{height: '25px', displayValue: false}" tag="svg"></barcode>
					<p class="barcode"><b>{{ item.multiBarcodes[0] }}</b></p>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
import PricesService from "../../../../services/prices.service";

export default {
	name: "pricingPrices",
	data() {
		return {
			items: [],
			deps: []
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			window.print();
		}
	},
	created() {
		PricesService.aktPricingList(this.$route.params.id).then(res => {
			this.items = res.data
		})
		PricesService.getDepartments().then(res => {
			this.deps = res.data
		})
	}
}
</script>

<style scoped>
body {
	background-color: white !important;
}

.printElement {
	padding-left: 10px !important;
	text-align: center;
	page-break-before: always;
	page-break-after: always;
	page-break-inside: avoid;
	word-break: break-all;
	color: #000;
	width: 100mm !important;
	height: 50mm !important;
	border: 1px dashed #868686;
	background-color: white;
}
.printElement svg {
	width: 100% !important;
	margin-top: -3px;
}

.printElement p {
	font-family: "Arial Black", Gadget, sans-serif;
	text-align: center;
	color: #000000 !important;
	font-weight: bold;
	font-size: 15px !important;
	margin: 0;
	line-height: 1;
}

.specialBarcode {
	font-size: 17px;
	padding-left: 40%;
}

.printElement .price {
	margin-top: -5px !important;
	font-size: 55px !important;
}
.printElement p.barcode {
	font-size: 10px;
}

@media print {
	html, body {
		margin: 0 !important;
		text-align: center;
		padding: 0 !important;
	}
	* {
		box-sizing: border-box;
		padding: 0;
		margin: 0;
	}
	@page { size: landscape; }
	.hidden-print {
		display: none;
	}
	.printElement {
		border: none;
	}

}
</style>
